import Drawable from '../entities/Drawable.js';
import { imageStore } from '../images.js';
import PixelText from './PixelText.js';
import Sprite from './Sprite.js';

export default class LocationBanner extends Drawable {
    constructor() {
        super();
        this.position = {
            x: 0,
            y: -32,
        };
        this.sprite = new Sprite({
            image: imageStore.get('img/location_banner.png'),
            position: { x: 0, y: -32 },
        });
        this.locationText = new PixelText({
            text: 'Test Town',
            color: PixelText.whiteTextColor,
            shadowColor: PixelText.blackShadowColor,
            textAlign: 'center',
        });
    }

    show() {
        this.sprite.animationQueue = [];
        this.sprite.addAnimation({
            animationFunction: () => {
                this.position.y = -32;
            },
            speed: 1,
            duration: 1,
        });
        this.sprite.addAnimation({
            animationFunction: () => {
                this.position.y += 1;
            },
            speed: 1,
            duration: 32,
        });
        this.sprite.addAnimation({
            animationFunction: () => {},
            speed: 0,
            duration: 120,
        });
        this.sprite.addAnimation({
            animationFunction: () => {
                this.position.y -= 1;
            },
            speed: 1,
            duration: 32,
        });
    }

    draw() {
        this.sprite.position = this.position;
        this.locationText.position = {
            x: this.position.x + 96 / 2,
            y: this.position.y + 11,
        };
        this.sprite.draw();
        this.locationText.draw();
    }
}
